export const AGENT_TRUST_RECEIPT_PANEL_ID = 'agentReceiptPanel';

// Durable content property value set by Rovo Smart Create. Matched as an exact literal so that
// other generatedBy values (null, ONBOARDING, AI_PLANNER) are NOT treated as Rovo-created.
export const ROVO_SMART_CREATION_GENERATED_BY = 'ROVO_SMART_CREATION';

export type AgentTrustReceiptScenarioId = 'CREATED_BY_AI' | 'EDITED_BY_AI' | 'READ_BY_AI';

// Real page data, already loaded at View Page load, used to hydrate the CREATED_BY_AI receipt.
// All fields are optional so the resolver stays backward compatible when no data is supplied.
export type AgentTrustReceiptPageData = {
	generatedBy?: string | null;
	creatorName?: string | null; // history.createdBy.displayName
	createdAt?: string | null; // history.createdDate (ISO 8601)
	lastUpdatedAt?: string | null; // version.when (ISO 8601)
	versionNumber?: number | null; // version.number
};

export type AgentTrustReceiptActorIconKey =
	| 'rovo-agent'
	| 'space-organizer-agent'
	| 'dev-docs-agent';

export type AgentTrustReceiptAgentType = 'rovo' | 'space-organizer' | 'dev-docs';

export type AgentTrustReceiptActor = {
	id: string;
	name: string;
	type: 'agent' | 'person';
	agentType: AgentTrustReceiptAgentType;
	iconKey: AgentTrustReceiptActorIconKey;
};

export type AgentTrustReceiptScenario = {
	id: AgentTrustReceiptScenarioId;
	label: string;
	description: string;
};

export type AgentTrustReceiptSignal = {
	id: string;
	label: string;
	value: string;
};

export type AgentTrustReceiptEvent = {
	id: string;
	occurredAt: string;
	title: string;
	description: string;
};

export type AgentTrustReceipt = {
	contentId: string;
	actor: AgentTrustReceiptActor;
	scenario: AgentTrustReceiptScenario;
	summary: string;
	events: AgentTrustReceiptEvent[];
	signals: AgentTrustReceiptSignal[];
};
